
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/azure-blob",
      function () {
        return require("private-next-pages/sources/azure-blob.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/azure-blob"])
      });
    }
  